import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './phone-number.magic.css.js';
import PhoneNumberComponent from './phone-number.js';

const __vue_script__ = PhoneNumberComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "magic-ui-form-field",
    _vm._b(
      { staticClass: "phone-number", attrs: { part: "phone-number" } },
      "magic-ui-form-field",
      _vm.$filteredAttrs,
      false
    ),
    [
      _c(
        "magic-ui-form-field",
        {
          staticClass: "prefix",
          attrs: {
            "no-margin": "",
            part: "prefix",
            "data-v-test-id": "phone-prefix",
            "has-error": _vm.$v.prefix.$error,
            "has-success": !!_vm.prefix && !_vm.$v.prefix.$invalid,
            "aria-label":
              _vm.$t("phone-number.prefix.aria-label") ||
              _vm.$t("sign-up-step-two.phone-prefix.aria-label")
          }
        },
        [
          _c("magic-ui-dropdown", {
            attrs: {
              placeholder: _vm.$t("sign-up-step-two.phone-prefix.placeholder"),
              "allow-empty": _vm.optional,
              value: _vm.$v.prefix.$model
            },
            domProps: { options: _vm.phonePrefixes },
            on: {
              change: [
                function($event) {
                  return _vm.$set(_vm.$v.prefix, "$model", $event.detail[0])
                },
                function($event) {
                  $event.stopPropagation();
                  return _vm.onChange()
                }
              ],
              blur: function($event) {
                $event.stopPropagation();
                return _vm.onChange()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "magic-ui-form-field",
        {
          staticClass: "number",
          attrs: {
            "no-margin": "",
            part: "number",
            "data-v-test-id": "phone-number",
            "has-error": _vm.$v.number.$error || _vm.$v.number.$invalid,
            "has-success": !!_vm.number && !_vm.$v.number.$invalid
          }
        },
        [
          _c("magic-ui-input", {
            ref: "phone",
            attrs: {
              type: "tel",
              placeholder: _vm.phonePlaceholder,
              value: _vm.$v.number.$model
            },
            on: {
              change: function($event) {
                $event.stopPropagation();
                return _vm.onChange()
              },
              blur: function($event) {
                $event.stopPropagation();
                return _vm.onChange()
              },
              beforeinput: _vm.preventNonDigits,
              input: function($event) {
                return _vm.$set(_vm.$v.number, "$model", $event.detail[0])
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-528165e0_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-528165e0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
